"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = require("semantic-ui-react");

var _constants = require("../../utils/constants");

var _PanelMessageGenerateAPP = require("./PanelMessageGenerateAPP.css");

var _PanelMessageGenerateAPP2 = _interopRequireDefault(_PanelMessageGenerateAPP);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

//     

var PanelMessageGenerateAPP = function (_Component) {
	_inherits(PanelMessageGenerateAPP, _Component);

	function PanelMessageGenerateAPP() {
		_classCallCheck(this, PanelMessageGenerateAPP);

		//this.state = {visible : true};
		var _this = _possibleConstructorReturn(this, (PanelMessageGenerateAPP.__proto__ || Object.getPrototypeOf(PanelMessageGenerateAPP)).call(this));

		_this.handleDismiss = function () {
			//this.setState({ visible: false })
			_this.props.showMessageGenerateAPP(false);
		};

		return _this;
	}

	_createClass(PanelMessageGenerateAPP, [{
		key: "getUrlApp",
		value: function getUrlApp(tipus, id, orga) {
			return _constants.URL_APP + "/" + tipus + "/" + orga + "/" + id;
		}
	}, {
		key: "openWindow",
		value: function openWindow(url) {
			var mode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "_blank";

			window.open(url, mode);
		}
	}, {
		key: "render",
		value: function render() {
			var _this2 = this;

			var urlVisor = this.getUrlApp("visor", this.props.visor, this.props.orga);
			var urlEditor = this.getUrlApp("editor", this.props.editor, this.props.orga);

			return _react2.default.createElement(
				"div",
				null,
				_react2.default.createElement(
					_semanticUiReact.Dimmer,
					{ active: true, onClickOutside: this.handleDismiss, page: true },
					_react2.default.createElement(
						"div",
						{ className: _PanelMessageGenerateAPP2.default.containerMessage },
						_react2.default.createElement(_semanticUiReact.Message, {
							color: "teal",
							onDismiss: this.handleDismiss,
							inverted: "true",
							attached: true,
							header: "Copia i enganxa url",
							content: ""
						}),
						_react2.default.createElement(
							"div",
							{ className: _PanelMessageGenerateAPP2.default.containerInput },
							_react2.default.createElement(
								_semanticUiReact.Input,
								{
									className: _PanelMessageGenerateAPP2.default.marginBottom,
									labelPosition: "left",
									readOnly: true, fluid: true,
									action: true,
									value: urlVisor, type: "text"
								},
								_react2.default.createElement(
									_semanticUiReact.Label,
									{ color: "teal" },
									"Url Visor\xA0"
								),
								_react2.default.createElement("input", null),
								_react2.default.createElement(
									_semanticUiReact.Button,
									{ color: "teal", icon: true, onClick: function onClick() {
											return _this2.openWindow(urlVisor);
										} },
									_react2.default.createElement(_semanticUiReact.Icon, { name: "share" })
								)
							),
							_react2.default.createElement(
								_semanticUiReact.Input,
								{
									labelPosition: "left",
									readOnly: true, fluid: true,
									value: urlEditor, type: "text"
								},
								_react2.default.createElement(
									_semanticUiReact.Label,
									{ color: "teal" },
									"Url Editor"
								),
								_react2.default.createElement("input", null)
							)
						)
					)
				)
			);
		}
	}]);

	return PanelMessageGenerateAPP;
}(_react.Component);

exports.default = PanelMessageGenerateAPP;


PanelMessageGenerateAPP.propTypes = {

	visor: _propTypes2.default.string,
	editor: _propTypes2.default.string,
	orga: _propTypes2.default.string,
	showMessageGenerateAPP: _propTypes2.default.func

};
